import { useTheme } from '@/assets/styles/themeMantine';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import type { BulkActionCallbacks } from '@/views/list/useBulkActionLogic';
import { useBulkActionLogic } from '@/views/list/useBulkActionLogic';
import { useShouldShowBulkActions } from '@/views/list/BulkActionDropdown.utils';
import { Button, Menu } from '@mantine/core';
import { ChevronDown } from 'react-feather';

export function BulkActionDropdown(callbacks: BulkActionCallbacks) {
  const intl = useClientTerminology();
  const theme = useTheme();
  const actions = useBulkActionLogic(callbacks);
  const shouldShowActionsResult = useShouldShowBulkActions();

  if (!shouldShowActionsResult) {
    return null;
  }

  return (
    <Menu
      shadow="md"
      position="bottom-start"
      transitionProps={{ duration: 100, transition: 'pop-top-left' }}
    >
      <Menu.Target>
        <Button
          style={{ width: 'fit-content' }}
          data-testid="bulk-actions-button"
          variant="outline"
          color={theme.other.mainColor.accent.normal}
          bd="1px solid var(--os-mainColor-outline-secondary)"
          radius="lg"
          size="sm"
          px="sm"
          rightSection={<ChevronDown size={16} />}
        >
          {intl.formatMessage({ id: 'action.actions' })}
        </Button>
      </Menu.Target>
      <Menu.Dropdown data-testid="bulk-actions-menu">
        {actions.map((action, index) => {
          const IconComponent = action.icon;
          return (
            <Menu.Item
              key={index}
              data-testid={`bulk-action-${action.labelId}`}
              disabled={action.disabled}
              onClick={action.action}
              leftSection={IconComponent ? <IconComponent size={16} /> : null}
              c="tealBrand"
            >
              {intl.formatMessage({ id: action.labelId })}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
